// STATIC sample data for the merchant dashboard preview. Replace with the merchant dashboard API later.
// The numbers are consistent on purpose:
//   gross revenue = vendor share + commission + convenience fees
//   vendor / kiosk / mode rows add up to the same totals shown in the KPI cards.

export const MERCHANT_PROFILE = {
  businessName: 'Nashik Print Merchants',
  contactEmail: 'merchnat@gmail.com',
  city: 'Nashik, Maharashtra',
  since: 'Jun 2026',
  lastLogin: 'Today, 11:32 AM',
};

export const PERIOD_LABEL = 'Last 7 days';

export const EARNINGS = {
  gross: 48250,
  vendorShare: 37792,
  commission: 7890,
  convenienceFees: 2568,
};

export const KPIS = [
  { key: 'gross', label: 'Gross revenue', value: '₹48,250', delta: '+12.4%', up: true, icon: 'bi-currency-rupee', note: 'vs previous 7 days' },
  { key: 'commission', label: 'Your commission', value: '₹7,890', delta: '+9.8%', up: true, icon: 'bi-piggy-bank', note: '16.4% of revenue' },
  { key: 'jobs', label: 'Print jobs', value: '1,284', delta: '+8.1%', up: true, icon: 'bi-file-earmark-text', note: '5,936 pages printed' },
  { key: 'kiosks', label: 'Online kiosks', value: '18 of 20', delta: '2 offline', up: false, icon: 'bi-printer', note: 'across 3 vendors' },
];

// revenue = vendorShare + commission (convenience fees are inside revenue and shown in the breakdown card)
export const DAILY = [
  { day: 'Mon', date: '13 Oct', revenue: 5200, commission: 850 },
  { day: 'Tue', date: '14 Oct', revenue: 6800, commission: 1110 },
  { day: 'Wed', date: '15 Oct', revenue: 4900, commission: 800 },
  { day: 'Thu', date: '16 Oct', revenue: 7600, commission: 1240 },
  { day: 'Fri', date: '17 Oct', revenue: 8300, commission: 1360 },
  { day: 'Sat', date: '18 Oct', revenue: 9100, commission: 1490 },
  { day: 'Sun', date: '19 Oct', revenue: 6350, commission: 1040 },
];

export const PRINT_MODES = [
  { mode: 'Black & white', jobs: 925, share: 72, revenue: 31600, commission: 5300, tone: 'primary' },
  { mode: 'Colour', jobs: 359, share: 28, revenue: 16650, commission: 2590, tone: 'secondary' },
];

export const ATTENTION = [
  { level: 'danger', title: 'Printer unreachable', kiosk: 'Shivajinagar', vendor: 'Campus Copy Hub', time: '22 min ago' },
  { level: 'warning', title: 'A4 tray almost empty (12 sheets)', kiosk: 'Pune Camp', vendor: 'Testing Prints', time: '6 min ago' },
  { level: 'warning', title: '2 failed payments today', kiosk: 'Nashik Road Station', vendor: 'Demo Print Vendor', time: '31 min ago' },
  { level: 'info', title: 'Rate card #10 has no kiosks assigned', kiosk: '—', vendor: 'Testing Prints', time: 'Setup' },
];

export const VENDORS = [
  { name: 'Demo Print Vendor', kiosks: 8, online: 8, jobs: 598, revenue: 22400, commission: 3650 },
  { name: 'Testing Prints', kiosks: 7, online: 6, jobs: 421, revenue: 15850, commission: 2580 },
  { name: 'Campus Copy Hub', kiosks: 5, online: 4, jobs: 265, revenue: 10000, commission: 1660 },
];

export const TOP_KIOSKS = [
  { name: 'Nashik Road Station', vendor: 'Demo Print Vendor', revenue: 9450, jobs: 262 },
  { name: 'College Road', vendor: 'Demo Print Vendor', revenue: 7820, jobs: 219 },
  { name: 'Pune Camp', vendor: 'Testing Prints', revenue: 6310, jobs: 168 },
  { name: 'Gangapur Road', vendor: 'Demo Print Vendor', revenue: 5980, jobs: 171 },
  { name: 'Shivajinagar', vendor: 'Campus Copy Hub', revenue: 4120, jobs: 117 },
];

export const TRANSACTIONS = [
  { id: 'TXN-10482', kiosk: 'Nashik Road Station', mode: 'B/W', amount: 50, commission: 12, fee: 2, status: 'Success', time: '2 min ago' },
  { id: 'TXN-10481', kiosk: 'College Road', mode: 'Colour', amount: 64, commission: 10, fee: 2, status: 'Success', time: '9 min ago' },
  { id: 'TXN-10480', kiosk: 'Pune Camp', mode: 'B/W', amount: 14, commission: 3, fee: 2, status: 'Pending', time: '14 min ago' },
  { id: 'TXN-10479', kiosk: 'Nashik Road Station', mode: 'Colour', amount: 40, commission: 6, fee: 2, status: 'Failed', time: '31 min ago' },
  { id: 'TXN-10478', kiosk: 'Gangapur Road', mode: 'B/W', amount: 18, commission: 4, fee: 2, status: 'Success', time: '48 min ago' },
  { id: 'TXN-10477', kiosk: 'Pune Camp', mode: 'B/W', amount: 98, commission: 24, fee: 2, status: 'Success', time: '1 hr ago' },
];
